import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuth } from '@/stores/auth';

const GATED = ['desk', 'bursar', 'teacher', 'parent', 'student', 'applicant'];

/** Pages the school switched off for me (my role, or my custom role). Empty while loading or for the owner. */
export function useMyAccess() {
  const role = useAuth((s: any) => s.user?.role);
  const q = useQuery({
    queryKey: ['me-access', role],
    enabled: GATED.includes(role),
    queryFn: () => api.get('/me/access').then((r) => (r.data?.data ?? r.data) as { role: string; hidden: string[]; custom_role: string | null }),
    staleTime: 60_000,
    retry: false,
  });
  return { hidden: q.data?.hidden ?? [], customRole: q.data?.custom_role ?? null };
}
